import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    // visible: false,
    keyword: ''
  },
  reducers: {
    // toggleModal: (state) => ({ ...state, visible: !state.visible }),
    setKeyword: (state, { payload }) => ({ ...state, ...payload })
  }
})

export const { toggleModal, setKeyword } = searchSlice.actions

export default searchSlice.reducer